import React, {useState, useCallback} from "react"
import { useTranslation, I18nextContext} from 'gatsby-plugin-react-i18next';
import './subscribe-form.scss';
import {ModalOverlay} from '../modal-overlay/modal-overlay';
import imageModal1 from "../../images/modal/modal-subscribe1.jpg";
import imageModal2 from "../../images/modal/modal-subscribe2.jpg";
import imageCodeWe from "../../images/modal/code-we.jpg";
import imageCodeKa from "../../images/modal/code-ka.jpg";

export const SubscribeForm = (props, ref) => {
  const { t } = useTranslation();
  const [error, setError] = useState(false);
  const [placeholder, setPlaceholder] = useState(t('inputMail'));
  const [overlay, setVisible] = useState(false);
  const [overlayCode, setVisibleCode] = useState(false);
  const [title, setTitle] = useState(t('sub title modal'));
  const [desc, setDesc] = useState(t('description modal'));

  const titleWe = t('title modal we');
  const titleKa = t('title modal ka');

  const src1 = imageModal1;
  const src2 = imageModal2;
  let imgCode = null;
  if(t('wechat') === 'true') {
    imgCode = imageCodeWe;
  }
  if(t('Kakao') === 'true') {
    imgCode = imageCodeKa;
  }

  const context = React.useContext(I18nextContext);
  let lang = context.language;

  function checkValueInput (e) {
    const mailInput = document.querySelector('.j-inputMail');
    const mailValue = mailInput.value;
    e.preventDefault();
    if(mailInput.value) {
      if(!isValidEmailAddress(mailValue)) {
        mailInput.value = '';
        setPlaceholder(t('wrong email'));
        setError(true);
      } else {
        const finalUrl = '/api/webform';
        // const currentUrl = window.location.origin;
        const correctUrl = 'hiroshifujiwara';
        const url = '/' + correctUrl + finalUrl;
        const params = "Email__c="+mailValue+"&SessionLanguage__c="+lang;
        const xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
          if(this.readyState === 4) {
            setError(false);
            setPlaceholder(t('inputMail'));
            if (this.status < 400) {
              const response = xhttp.response
              const responseObj = JSON.parse(response);
              if(responseObj.success) {
                setTitle(t('sub title modal'));
                setDesc(t('description modal'));
                setVisible(true);
                window.dataLayer.push({
                  event: 'subscription',
                  EventCategory: 'subscription',
                  EventAction: lang,
                  Eventlabel : 'formfujiuara1/Fujiuara form'
                });                
              } else {
                setTitle(t('sub title modal error'));
                setDesc(t('description modal error'));
                setVisible(true);
              }
              mailInput.value = '';
            } else {
              setError(false);
              setPlaceholder(t('inputMail'));
              setTitle(t('sub title modal error'));
              setDesc(t('description modal error'));
                setVisible(true);
                mailInput.value = '';
            }
          }
        };
        xhttp.open("POST", url, true);
        xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xhttp.send(params);
      }
    }
  }

  function isValidEmailAddress(emailAddress) {
    var pattern = new RegExp(/^(("[\w-+\s]+")|([\w-+]+(?:\.[\w-+]+)*)|("[\w-+\s]+")([\w-+]+(?:\.[\w-+]+)*))(@((?:[\w-+]+\.)*\w[\w-+]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][\d]\.|1[\d]{2}\.|[\d]{1,2}\.))((25[0-5]|2[0-4][\d]|1[\d]{2}|[\d]{1,2})\.){2}(25[0-5]|2[0-4][\d]|1[\d]{2}|[\d]{1,2})\]?$)/i);
    return pattern.test(emailAddress);
  }

  const openOverlay = useCallback(
    (e) => {
      e.preventDefault();
      setVisibleCode(true);
    },
    [],
  )

  const onCloseOverlay = useCallback(
    (e) => {
      e.preventDefault();
      setVisible(false);
      setVisibleCode(false);
    },
    [],
  )

  return (
    <div className="subscribeForm">
      {
        props.hasText &&
        <span className="subscribeForm__title"> {t('subscribeournews')}</span>
      }
      {
        (props.hasdescription && t('subtitleNLSubscription') ) &&
        <p className="subscribeForm__labelForm" dangerouslySetInnerHTML={{__html: props.hasdescription}}></p>
      }
      {
      t('mail subscribe') === 'true' &&
      <div className="subscribeForm__formContainer">
        <form className={`${error ? 'subscribeForm__form--error' : ''} subscribeForm__form`}>
          <label className="subscribeForm__formLabel" htmlFor="fmail">{t('inputMail')}</label>
          <input className="subscribeForm__formInput j-inputMail" type="text" id="fmail" name="fmail" placeholder={placeholder} />
          <button type="submit" className="subscribeForm__formButton" onClick={checkValueInput}>
            {t('Subscribe button')}
            <span className="subscribeForm__formButtonIcon i-dropdown"></span>
          </button>
        </form>
        <p className="subcribeForm__paragraph">{t('agree')}</p>
        <ModalOverlay stateOverlay={overlay} titleModal={title} descModal={desc} contentImage='true' srcImage1={src1} srcImage2={src2} onCloseOverlay={onCloseOverlay}></ModalOverlay>
      </div>
      }
      {
        t('wechat') === 'true' &&
        <div className="subscribeFrom__alternative">
          <a href="#" className="subscribeForm__alternativeText" onClick={openOverlay}>{t('Join us')}</a>
          <span className="subscribeForm__alternativeIcone i-wechat"></span>
          <ModalOverlay stateOverlay={overlayCode} codeImage='true'  titleModal={titleWe} onCloseOverlay={onCloseOverlay} srcCode={imgCode} iconTitle="i-wechat"></ModalOverlay>
        </div>
      }
      {
        t('Kakao') === 'true' &&
        <div className="subscribeFrom__alternative">
          <a href="#" className="subscribeForm__alternativeText" onClick={openOverlay}>{t('Join us')}</a>
          <span className="subscribeForm__alternativeIcone i-kakao"></span>
          <ModalOverlay link="http://pf.kakao.com/_txhSds" stateOverlay={overlayCode} codeImage='true' titleModal={titleKa} onCloseOverlay={onCloseOverlay} srcCode={imgCode} iconTitle="i-kakao"></ModalOverlay>
        </div>
      }

    </div>
  )
}